module.exports = __webpack_public_path__ + "img/zhangjiakou-map.522e0edf.png";